import classnames from 'classnames';
import React from 'react';

import { NavLink } from '../../../router/NavLink';
import { useLocation } from '../../../router/router';
import { renderUI } from '../../../util';

export interface ListCProps {
  headingClass?: string;
  headingTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  items: Array<{
    label?: string;
    link?: string;
  }>;
  title: string;
}
export const ListC = ({ headingClass, headingTag, items, title }: ListCProps) => {
  const { pathname } = useLocation();
  const contentFocusRef = React.useRef<HTMLDivElement>(null);
  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    contentFocusRef.current?.focus();
  }, [pathname]);

  return renderUI({
    bs5: (
      <div className="ListC">
        {/* Sentinel visivamente nascosto: riceve il focus al cambio di rotta per
            spostare lo screen reader e la navigazione da tastiera sul nuovo contenuto */}
        <div aria-live="polite" className="visually-hidden" ref={contentFocusRef} tabIndex={-1} />
        {React.createElement(
          headingTag || 'div',
          {
            className: classnames('aside-menu-title py-3 px-4 px-lg-5 bg-primary mb-1', headingClass),
          },
          title,
        )}

        <nav aria-label={title}>
          <div className="aside-menu-item vstack gap-2 bg-white py-3">
            {items.map((item) => (
              <NavLink
                aria-current={undefined}
                className="text-reset text-decoration-none py-1 px-4 px-lg-5 small"
                key={item.label}
                silent
                to={item.link}
              >
                {({ isActive }) => (
                  <span
                    aria-current={isActive ? 'page' : undefined}
                    className={classnames(isActive && 'border-bottom border-primary border-3 py-1')}
                  >
                    {item.label}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    ),
  });
};
